module.exports = __webpack_public_path__ + "static/media/knex.4c78356f.png";